import { ActionType, createAction } from 'typesafe-actions'

import { SearchProductResponse } from './types'

export const ProductsActions = {
  loadProducts: createAction('SEARCH/load-products')<{
    domainCode: string
    countryCode: string
    type: string | undefined
    allowAccountingSource?: boolean
    productCategory?: 'CompanyDocument' | 'Report' | 'All'
  }>(),
  setLoadedProducts: createAction('SEARCH/set-products')<{
    products: SearchProductResponse[]
  }>()
}

export type ProductsActions = ActionType<typeof ProductsActions>
